import React from 'react';
import styled from 'styled-components';

import InfoContainer from './InfoContainer';
import { formatDate } from '../utils/format-date';

interface Props {
  className?: string;
  invoiceDate: string;
  terms: string;
  dueDate: string;
  datesOfService: string[];
}

const DatesInfo = ({ invoiceDate, terms, dueDate, datesOfService, className }: Props) => {
  return (
    <DatesInfoContainer className={className}>
      <span>Invoice Date:</span> {formatDate(invoiceDate)}
      <span>Terms:</span> {terms}
      <span>Due Date:</span> {formatDate(dueDate)}
      <span>Date(s) of Service:</span> {datesOfService.map(formatDate).join(',')}
    </DatesInfoContainer>
  );
};

const DatesInfoContainer = styled(InfoContainer)`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media ${({ theme }) => theme.queries.minTablet} {
    text-align: end;
  }
`;

export default DatesInfo;
